import { styled } from "@mui/material/styles";
const OrderQuotesMain = styled("div")(({ theme }) => ({
  background: "#FFFFFF",
  border: "1px solid #D1D1D1",
  boxShadow: "0px 0px 4.70588px rgba(0, 0, 0, 0.05)",
  borderRadius: "16px",
  padding: "20px",
  marginBottom: "20px",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },

  [theme.breakpoints.down("md")]: {
    padding: "14px",
    width: "100%",
  },

  // [theme.breakpoints.up("lg")]: {
  //   width: "80%",
  // },
}));

const QuotesHead = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  marginBottom: "20px",
  position: "relative",
  "& .title": {
    "& h6": {
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "18px",
      lineHeight: "18px",
      color: "#0B0B0B",
    },
  },
  "& img": {
    position: "absolute",
    right: 0,
    top: "70%",
    transform: "translateY(-60%)",
    width: "30px",
    height: "30px",
  },
  [theme.breakpoints.down("md")]: {
    justifyContent: "start",
    "& img": {
      width: "20px",
      height: "20px",
    },
  },
}));

const QuotesContant = styled("div")(({ theme }) => ({
  margin: "0 auto",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },

  [theme.breakpoints.up("md")]: {
    width: "100%",
  },

  [theme.breakpoints.up("lg")]: {
    width: "80%",
  },

  "& div": {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
    gap: "10px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "16px",
      lineHeight: "16px",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
    "& p": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "16px",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
      display: "inline-block",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    [theme.breakpoints.down("md")]: {
      gap: "8px",
      "& p": { fontSize: "12px" },
      "& span": { fontSize: "12px" },
    },
  },
}));

const PriceSec = styled("div")(({ theme }) => ({
  margin: "0 auto",
  marginTop: "20px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },

  [theme.breakpoints.up("md")]: {
    width: "100%",
  },

  [theme.breakpoints.up("lg")]: {
    width: "80%",
  },
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "& .price_sec": {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "20px",
      lineHeight: "130%",
      color: "#191D31",
      fontFamily: theme.typography.fontFamily,
    },
  },
  "& .time_sec": {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    "& h6": {
      fontFamily: theme.typography.fontFamily,
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "20px",
      lineHeight: "20px",
      color: "#0B0B0B",
    },
    "& span": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "18px",
      lineHeight: "18px",
      textAlign: "right",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
  },
}));

const ButtonSec = styled("div")(({ theme }) => ({
  margin: "0 auto",
  marginTop: "20px",
  width: "100%",
  // [theme.breakpoints.down("sm")]: {

  // },

  // [theme.breakpoints.up("md")]: {
  //   width: "80%",
  // },

  // [theme.breakpoints.up("lg")]: {
  //   width: "100%",
  // },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "20px",
  "& button": {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "14.1176px",
    lineHeight: "19px",
    textAlign: "center",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    background: "#FFFFFF",
    border: "1px solid #0B0B0B",
    borderRadius: "23px",
    textTransform: "capitalize",
    width: "125px",
    height: " 37px",
    "&.approve": { background: "#0B0B0B", color: "#fff" },
  },
}));

const ContactMain = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },

  [theme.breakpoints.up("md")]: {
    width: "100%",
  },

  [theme.breakpoints.up("lg")]: {
    width: "70%",
  },
}));

export {
  OrderQuotesMain,
  QuotesHead,
  QuotesContant,
  PriceSec,
  ButtonSec,
  ContactMain,
};
